<template>
  <div style="display: flex;">
    <img v-if="iconUrl" class="image" :src="iconUrl" />
    <div v-if="!iconUrl" class="image"></div>
  </div>
</template>

<script>
export default {
  props: {
    src: { type: String, default: '' },
  },
  computed: {
    iconUrl() {
      if (!this.src) return ''
      else return this.src
    },
  },
}
</script>

<style scoped>
.image {
  width: 2rem;
  height: 2rem;
  box-sizing: border-box;
  border-radius: 4px;
  display: inline-block;
  border: 1px solid var(--paper-border-color);
  background-color: var(--paper-background-color);
  background-image: var(--default_profile_picture);
  background-size: cover;
}
</style>
